<template>
    <div class="playlist-container">
        <NavMenu :models="ruleNavItems" :key="'rules'" />

        <div class="main-content">
            <el-card class="playlist-title-card">
                <h1 class="playlist-title">雪音时光收藏馆 - 综合须知</h1>
                <p class="playlist-description">
                    本页面汇总雪音直播间所有核心规则与专属权益，涵盖点歌规则、积分兑换、二创活动、会员权益、官方社群规则、人设皮套使用规范、官方周边发放须知等，方便大家快速查阅。
                </p>
            </el-card>
        </div>

        <!-- 点歌规则 -->
        <div class="rulesCard" id="songRule" ref="ruleCard" data-id="songRule">
            <el-card>
                <h2 class="rulesTitle">🎵 点歌规则</h2>
                <p class="rulesDescription">
                    不同类型歌单消耗积分及规则不同，具体如下：
                </p>
                <el-tabs v-model="activeName">
                    <el-tab-pane label="个播点歌规则" name="first">
                        <transition name="el-fade-in-linear">
                            <div class="rulesContent">
                                <div class="table-header">
                                    <h3 style="font-size: 16px; color: #333; font-weight: bold; margin: 0;">
                                        🎵 个播不同类型歌单积分消耗及点歌规则
                                    </h3>
                                    <p style="font-size: 14px; color: #666; margin: 5px 0 0 0;">
                                        以下为个播各类歌单的积分消耗标准、优先级及对应点歌方式说明
                                    </p>
                                </div>
                                <el-table :data="songListTypes" border style="width: 100%; margin: 20px 0;">
                                    <el-table-column prop="name" label="歌单类型" width="180" />
                                    <el-table-column prop="cost" label="积分消耗" width="220">
                                        <template slot-scope="scope">
                                            <span v-html="scope.row.cost"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="priority" label="优先级" width="180" />
                                    <el-table-column label="点歌方式" width="180">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.orderMethod === 'admin'"
                                                style="color: #f56c6c; font-weight: bold;">
                                                {{ scope.row.orderMethodText }}
                                            </span>
                                            <span v-else>
                                                {{ scope.row.orderMethodText }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="note" label="备注" />
                                </el-table>

                                <!-- 点歌模板独立折叠控制 -->
                                <div class="collapse-control" style="margin: 10px 0;">
                                    <el-button type="text" @click="toggleTemplate"
                                        :icon="isTemplateCollapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                                        {{ isTemplateCollapse ? '展开点歌模板工具' : '收起点歌模板工具' }}
                                    </el-button>
                                </div>
                                <div v-show="!isTemplateCollapse" class="collapse-content" style="margin-top: 15px;">
                                    <div class="input-section">
                                        <h3 class="template-title">点歌模板</h3>
                                        <div class="template-form">
                                            <div class="form-item">
                                                <label class="form-label">歌单：</label>
                                                <el-input v-model="songList" placeholder="请输入歌单名称" class="form-input">
                                                </el-input>
                                            </div>
                                            <div class="form-item">
                                                <label class="form-label">抖音昵称：</label>
                                                <el-input v-model="douyinNickname" placeholder="请输入抖音昵称"
                                                    class="form-input">
                                                </el-input>
                                            </div>
                                            <div class="form-item">
                                                <label class="form-label">抖音id：</label>
                                                <el-input v-model="douyinId" placeholder="请输入抖音id" class="form-input">
                                                </el-input>
                                            </div>
                                            <div class="form-item">
                                                <label class="form-label">备注：</label>
                                                <el-input v-model="songNote" placeholder="请输入备注" type="textarea"
                                                    autosize class="form-input">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="template-buttons">
                                            <el-button id="copyBtn" type="primary">一键复制</el-button>
                                            <el-button type="default" @click="clearTemplate">清空模板</el-button>
                                        </div>
                                    </div>
                                </div>

                                <!-- 小程序码独立折叠控制 -->
                                <div class="collapse-control" style="margin: 10px 0;">
                                    <el-button type="text" @click="toggleQrcode"
                                        :icon="isQrcodeCollapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                                        {{ isQrcodeCollapse ? '展开点歌二维码' : '收起点歌二维码' }}
                                    </el-button>
                                </div>
                                <div v-show="!isQrcodeCollapse" class="collapse-content"
                                    style="margin-top: 15px; margin-bottom: 20px;">
                                    <div class="mini-program-section">
                                        <div class="qrcode-placeholder"
                                            style="width: 200px; height: 200px; background: #f5f5f5; margin: 0 auto; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #999;">
                                            <img src="../assets/点歌小程序.png" alt="点歌小程序"
                                                style="width: 100%; height: 100%;">
                                        </div>
                                        <p style="margin-top: 10px; color: #666; text-align: center;">
                                            📱 微信扫码进入拼团小程序<br>
                                        </p>
                                    </div>
                                </div>

                                <div class="reminder"
                                    style="margin-top: 20px; padding: 20px; background: #fff3cd; border-radius: 8px; color: #856404; line-height: 1.8;">
                                    <h4 style="margin: 0 0 10px 0; font-size: 15px; font-weight: bold; color: #856404;">
                                        ⚠️
                                        重要补充规则
                                    </h4>
                                    <ul style="margin: 0; padding-left: 20px; font-size: 14px;">
                                        <li>每日个播固定还歌 5 首。</li>
                                        <li>每位用户每日仅限排 1 首歌，不可多排。</li>
                                        <li>20 级灯牌用户每周额外获得 1 首点歌权益，不占用个播固定还歌数量。</li>
                                        <li>学歌歌单仅接受国语歌曲，不接受说唱、S 歌类型，排到后交付周期约 1 周。</li>
                                        <li>入团纪念日点歌需在纪念日当天，携带
                                            <el-tooltip placement="top" title="标题" width="200" trigger="hover"
                                                effect="light" content="抖音主页-全部功能-我的钱包-粉丝团-R.雪音粉丝团-查看。" :hide-after=0
                                                class="custom-tooltip">
                                                <span style="font-weight: bold;">入团天数</span>
                                            </el-tooltip>
                                            录屏（含北京时间展示）联系管理，自动扣除 1 积分。
                                        </li>
                                        <li>置顶歌单若因不可抗力未能如期还歌，可选择全额退还积分或重新约定交付时间。</li>
                                    </ul>
                                </div>
                            </div>
                        </transition>
                    </el-tab-pane>
                    <el-tab-pane label="排档点歌规则" name="second">
                        <transition name="el-fade-in-linear">
                            <div class="rulesContent">
                                <div class="table-header" style="margin: 0 0 10px 0;">
                                    <h3 style="font-size: 16px; color: #333; font-weight: bold; margin: 0;">
                                        🎤 点歌规则说明
                                    </h3>
                                    <p style="font-size: 14px; color: #666; margin: 5px 0 0 0;">
                                        排档分为两轮，点歌仅针对第二轮（P1），规则如下：
                                    </p>
                                </div>

                                <!-- 排档流程说明 -->
                                <div class="process-card"
                                    style="margin-bottom: 20px; border: 1px solid #e6e6e6; border-radius: 8px; overflow: hidden;">
                                    <div class="process-step"
                                        style="background: #f0f9ff; padding: 15px; border-bottom: 1px solid #e6e6e6;">
                                        <h4 style="margin: 0; color: #2563eb; font-size: 15px;">第一轮：轮麦 (不可点歌)</h4>
                                        <p style="margin: 5px 0 0 0; color: #666; font-size: 14px;">
                                            麦上每位主播依次演唱 1 首，顺序由排档机制决定，不支持点唱。
                                        </p>
                                    </div>
                                    <div class="process-step" style="background: #fdf2f8; padding: 15px;">
                                        <h4 style="margin: 0; color: #be185d; font-size: 15px;">第二轮：P1 (点歌环节)</h4>
                                        <p style="margin: 5px 0 0 0; color: #666; font-size: 14px;">
                                            观众通过赠送礼物点歌，主播按照礼物优先级和金额排序进行演唱。
                                        </p>
                                    </div>
                                </div>

                                <!-- P1 排序规则 -->
                                <div class="rule-card" style="margin-bottom: 20px;">
                                    <h4 style="font-size: 15px; color: #333; margin-bottom: 10px;">🔢 P1 演唱排序逻辑</h4>
                                    <ul style="padding-left: 20px; color: #666; line-height: 1.8;">
                                        <li><strong>优先级顺序</strong>：置顶歌单 > 插队歌单 > 手速歌单。</li>
                                        <li><strong>同优先级排序</strong>：
                                            <ul style="margin-top: 5px; padding-left: 20px;">
                                                <li><strong>置顶</strong>：按礼物累加金额 <strong>降序</strong> 排列（累加金额越大越靠前）。</li>
                                                <li><strong>插队</strong>：按单个礼物金额 <strong>降序</strong> 排列（金额越大越靠前）。</li>
                                                <li><strong>手速歌单</strong>：按点歌时间 <strong>先到先得</strong>（需满足单个礼物金额门槛）。</li>
                                            </ul>
                                        </li>
                                        <li><strong>礼物金额判定规则</strong>：
                                            <ul style="margin-top: 5px; padding-left: 20px;">
                                                <li><strong>手速/插队歌单</strong>：仅计算「单个礼物」金额，连击多个小额礼物不计入（例：连击599个1钻礼物，不满足手速歌单≥599钻门槛；连击2个9999钻礼物，视为2个插队歌单点歌）。
                                                </li>
                                                <li><strong>置顶歌单</strong>：支持同个礼物连击后金额累加（例：3个1万钻礼物累加为3万钻，可点1首置顶歌单，优先级高于1个2万钻礼物的置顶歌单）。
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>

                                <!-- 门槛说明 -->
                                <div class="threshold-card"
                                    style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 20px;">
                                    <h4 style="font-size: 15px; color: #333; margin-bottom: 10px;">🎁 礼物门槛参考</h4>
                                    <div style="display: flex; flex-wrap: wrap; gap: 15px;">
                                        <div class="threshold-item" style="flex: 1; min-width: 200px;">
                                            <span style="font-weight: bold; color: #d97706;">手速歌单：</span>
                                            <span>单个礼物价值 ≥ 599 钻</span>
                                        </div>
                                        <div class="threshold-item" style="flex: 1; min-width: 200px;">
                                            <span style="font-weight: bold; color: #059669;">插队歌单：</span>
                                            <span>单个礼物价值 ≥ 5000 钻</span>
                                        </div>
                                        <div class="threshold-item" style="flex: 1; min-width: 200px;">
                                            <span style="font-weight: bold; color: #b91c1c;">置顶点歌：</span>
                                            <span>单个/累加礼物价值 ≥ 10000 钻 (参考)</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- 新增：特别说明 -->
                                <div class="special-notice"
                                    style="background: #e6fffa; border: 1px solid #99f6e4; padding: 15px; border-radius: 8px;">
                                    <h4
                                        style="font-size: 15px; color: #0284c7; margin: 0 0 10px 0; display: flex; align-items: center;">
                                        <i class="el-icon-info" style="margin-right: 8px;">
                                        </i>
                                        特别说明
                                    </h4>
                                    <ul style="margin: 0; padding-left: 24px; color: #047857; line-height: 1.6;">
                                        <li><strong>顺延机制</strong>：若本档因时间原因未唱完，未唱上的歌曲将自动顺延至下个排档继续轮候。</li>
                                        <li><strong>积分兑换</strong>：排档期间赠送的礼物，若不打算用于点歌，也可以联系管理换算成积分，用于兑换其他周边或权益。</li>
                                    </ul>
                                </div>
                            </div>
                        </transition>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </div>
        <!-- 积分兑换 -->
        <div class="rulesCard" id="pointExchange" ref="ruleCard" data-id="pointExchange">
            <el-card>
                <div class="rulesContent">
                    <h2 class="rulesTitle">💎 积分兑换规则</h2>
                    <p class="rulesDescription">
                        积分由直播间礼物价值换算获得，仅支持指定礼物类型参与兑换。
                    </p>

                    <div class="rule-calculator-container">
                        <div class="rule-section">
                            <div class="exchange-core"
                                style="margin: 20px 0; padding: 15px; background: #f8f9fa; border-radius: 8px;">
                                <h3 style="font-size: 16px; margin: 0 0 15px 0; color: #333;">📌 核心换算规则</h3>
                                <ul class="exchange-list"
                                    style="padding-left: 20px; margin: 0; font-size: 14px; color: #666; line-height: 1.8;">
                                    <li>单个礼物价值 <strong style="color: #ffad32;">≥ 599钻</strong> 方可参与积分兑换。</li>
                                    <li>积分换算方式：<strong style="color: #ffad32;">积分 = 单个礼物钻数 ÷ 599，只舍不入，向下取整</strong>。
                                    </li>
                                    <li>积分换算无上限，礼物价值越高，可兑换的积分越多。</li>
                                </ul>

                                <p
                                    style="margin: 0; padding-top: 10px; border-top: 1px dashed #fccde3; font-size: 13px; color: #e53e3e; font-weight: bold;">
                                    ⚠️ 特别说明：限时积分兑换活动以主播实时口播为准，活动结束后恢复标准规则。
                                </p>
                            </div>

                            <div class="exchange-exclude"
                                style="margin-top: 20px; padding: 15px; background: #fdf2f8; border-radius: 8px;">
                                <h3 style="font-size: 16px; margin: 0 0 10px 0; color: #333;">🚫 不参与积分兑换的项目</h3>

                                <ul
                                    style="padding-left: 20px; margin: 0 0 10px 0; font-size: 14px; color: #666; line-height: 1.6;">
                                    <li><strong>星守护</strong></li>
                                    <li><strong>高级弹幕</strong></li>
                                    <li><strong>付费连线</strong>：主播开启连线功能时，用于付费插队/加塞的消耗。</li>
                                </ul>

                                <p
                                    style="margin: 0; padding-top: 10px; border-top: 1px dashed #fccde3; font-size: 13px; color: #e53e3e; font-weight: bold;">
                                    ⚠️ 特别说明：上述项目虽消耗钻石，但不计入任何积分，也不可用于点歌或周边兑换。
                                </p>
                            </div>

                            <div class="exchange-notice"
                                style="margin-top: 20px; padding: 15px; background: #f0f9ff; border-radius: 8px;">
                                <h3 style="font-size: 16px; margin: 0 0 10px 0; color: #333;">📢 积分使用须知</h3>
                                <ul
                                    style="padding-left: 20px; margin: 0; font-size: 14px; color: #666; line-height: 1.6;">
                                    <li>积分可用于兑换个播与排档点歌（普通、插队、置顶、学歌等）及相关周边福利。</li>
                                    <li>排档期间未唱到的点歌礼物，可按本规则申请转为积分，积分长期有效，永不清除。</li>
                                    <li>积分仅可用于本人使用，不支持提现、转赠他人或进行任何形式的交易。</li>
                                </ul>
                            </div>
                        </div>

                        <div class="calculator-section">
                            <div style="height: 100%; display: flex; flex-direction: column;width: 100%;">
                                <h3 style="font-size: 16px; margin: 0 0 20px 0; color: #333; font-weight: bold;">🎯
                                    积分计算器</h3>

                                <div class="calc-item" style="margin-bottom: 15px;">
                                    <label
                                        style="font-size: 14px; color: #666; display: block; margin-bottom: 5px;">礼物单价（钻石）</label>
                                    <el-input v-model.number="giftPrice" type="number" min="1" placeholder="请输入礼物钻石价格"
                                        style="width: 100%;"></el-input>
                                </div>

                                <div class="calc-item" style="margin-bottom: 15px;">
                                    <label
                                        style="font-size: 14px; color: #666; display: block; margin-bottom: 5px;">礼物数量</label>
                                    <el-input-number v-model="giftQuantity" :min="1" :step="1"
                                        style="width: 100%;"></el-input-number>
                                </div>

                                <div class="calc-buttons" style="display: flex; gap: 10px; margin-bottom: 15px;">
                                    <el-button type="primary" @click="addToPool" style="flex: 1;">添加到计算池</el-button>
                                    <el-button type="warning" @click="clearPool" style="flex: 1;">清空计算池</el-button>
                                </div>

                                <div class="pool-list"
                                    style="margin-bottom: 15px; flex: 1; overflow-y: auto; max-height: 180px;">
                                    <el-table :data="calculationPool" size="small" style="width: 100%;">
                                        <el-table-column prop="price" label="单价(钻)" width="100" />
                                        <el-table-column prop="quantity" label="数量" width="80" />
                                        <el-table-column prop="totalPrice" label="总价(钻)" width="100" />
                                        <el-table-column label="积分小计" prop="points" width="100" />
                                        <el-table-column label="操作" width="80">
                                            <template slot-scope="scope">
                                                <el-button @click="removeFromPool(scope.row.id)" size="mini"
                                                    type="text">移除</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="calc-result"
                                    style="padding: 15px; background: #f8f9fa; border-radius: 8px;">
                                    <div style="margin-bottom: 8px; font-size: 14px; color: #666;">
                                        <span>总钻石数：</span>
                                        <span style="font-weight: bold; color: #333;">{{ totalDiamonds }} 钻</span>
                                    </div>
                                    <div style="margin-bottom: 8px; font-size: 14px; color: #666;">
                                        <span>可兑换积分：</span>
                                        <span style="font-weight: bold; color: #409eff; font-size: 16px;">{{ totalPoints
                                            }}</span>
                                    </div>
                                    <div style="font-size: 14px; color: #666;">
                                        <span>溢出钻石数：</span>
                                        <span style="font-weight: bold; color: #e53e3e;">{{ totalOverflow }} 钻</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 二创积分规则 -->
        <div class="rulesCard" id="creationPoint" ref="ruleCard" data-id="creationPoint">
            <el-card style="border-radius: 8px; box-shadow: 0 2px 12px rgba(0,0,0,0.05);">
                <h2 class="rulesTitle" style="margin: 0 0 15px 0; font-size: 18px; color: #333;">🎬 二创积分规则</h2>
                <p class="rulesDescription" style="margin: 0 0 20px 0; line-height: 1.6;">
                    <span
                        style="color: #e53e3e; font-weight: bold;">重要说明：</span>二创积分与礼物兑换积分是两套独立系统，二创积分仅可在二创周边商城兑换周边，不可与礼物积分互通。
                </p>
                <div class="rulesContent" style="padding: 0; line-height: 1.8;">
                    <!-- 活动基础信息 -->
                    <div style="margin-bottom: 20px; padding: 15px; background: #f5fafe; border-radius: 8px;">
                        <h3 style="font-size: 15px; color: #2563eb; margin: 0 0 10px 0; font-weight: bold;">
                            📅 活动基础信息
                        </h3>
                        <ul style="margin: 0; padding-left: 20px; font-size: 14px; color: #666;">
                            <li>活动名称：《雪音的童话记事簿》二创活动</li>
                            <li>活动时间：每月1日 ~ 31日</li>
                        </ul>
                    </div>

                    <!-- 一、参与方式 -->
                    <div style="margin-bottom: 20px;">
                        <span style="font-weight: bold; color: #333; font-size: 15px;">1. 参与方式：</span>
                        <ul style="margin: 8px 0 0 20px; padding: 0; font-size: 14px; color: #666;">
                            <li>在抖音发布时长≥15秒的作品，添加活动主话题 <code
                                    style="background: #f5f5f5; padding: 2px 6px; border-radius: 4px;">#雪音的童话记事簿</code>，并
                                <code style="background: #f5f5f5; padding: 2px 6px; border-radius: 4px;">@R.雪音</code>。
                            </li>
                            <li>将作品投递至抖音二创话题页面下，即视为成功参与活动。</li>
                        </ul>
                    </div>

                    <!-- 二、投稿方向 -->
                    <div style="margin-bottom: 20px;">
                        <span style="font-weight: bold; color: #333; font-size: 15px;">2. 投稿方向：</span>
                        <ul style="margin: 8px 0 0 20px; padding: 0; font-size: 14px; color: #666;">
                            <li>💡 安利爱播类：直播混剪、唱歌混剪、名场面剪辑、直播内容整活等。</li>
                            <li>🎨 粉丝才艺类：形象饭绘、手书视频、合唱等。</li>
                            <li>📝 日常记录类：趣味互动、搞笑瞬间、追爱播日常/历程等。</li>
                        </ul>
                    </div>

                    <!-- 三、积分获取规则（核心优化：消除表格空白） -->
                    <div style="margin-bottom: 20px;">
                        <span style="font-weight: bold; color: #333; font-size: 15px;">3. 积分获取规则：</span>
                        <div style="margin: 8px 0 10px 20px;">
                            <p style="margin: 0 0 8px 0; font-size: 14px; color: #666;">单条视频按最高档结算，不可叠加：</p>
                            <!-- 优化表格：宽度自适应，消除空白 -->
                            <el-table :data="creationPointsRules" border size="small"
                                style="font-size: 14px; width: auto; min-width: 250px; border-radius: 4px;"
                                :header-cell-style="{ background: '#f5fafe', color: '#333' }">
                                <el-table-column prop="likeCount" label="单条视频点赞数" align="center" min-width="120" />
                                <el-table-column prop="points" label="对应积分" align="center" min-width="80" />
                            </el-table>
                            <p style="margin: 8px 0 0 0; font-size: 14px; color: #666;">
                                ✨ 单个ID账号下的多条达标视频，积分可累计（例：3条视频点赞破2930,单条视频点赞破2930计10积分，累计30积分）。
                            </p>
                        </div>
                    </div>

                    <!-- 四、领奖与周边兑换 -->
                    <div style="margin-bottom: 20px;">
                        <span style="font-weight: bold; color: #333; font-size: 15px;">4. 领奖与周边兑换：</span>
                        <ul style="margin: 8px 0 0 20px; padding: 0; font-size: 14px; color: #666;">
                            <li>📝 登记时间：活动结束后5个工作日内（次月5日24:00前），将视频链接私信
                                <a href="https://v.douyin.com/9gYyuxyp7oU/" target="_blank"
                                    style="color: #2563eb; text-decoration: none;" class="custom-link">
                                    艾雪
                                </a>
                                （DY：JOKERSTEAFAN613.）登记，逾期视为放弃。
                            </li>
                            <li>💎 积分生效：登记后的积分长期有效，可累积使用。</li>
                            <li>🛒 兑换方式：每月获奖名单由
                                <a href="https://v.douyin.com/NFkqMgUaVpw/" target="_blank"
                                    style="color: #2563eb; text-decoration: none;" class="custom-link">
                                    雪音の小助理
                                </a>
                                （DY：24226809254）公布后，二创周边商城限时开放5天，在微信小程序「拼团二创周边商城」用积分兑换周边。
                            </li>
                            <li>📦 发放时间：商城关闭后90个工作日内发放周边。</li>
                        </ul>
                    </div>

                    <!-- 五、注意事项 -->
                    <div style="margin-bottom: 0;">
                        <span style="font-weight: bold; color: #333; font-size: 15px;">5. 注意事项：</span>
                        <ul style="margin: 8px 0 0 20px; padding: 0; font-size: 14px; color: #666;">
                            <li>作品需首次发布，且R.雪音出镜率≥70%；一个视频仅可添加1个二创话题。</li>
                            <li>无意义视频、非原创视频、重复参与视频、涉及争议的作品均视为无效。</li>
                            <li>二创周边商城内的周边会不定期更新。</li>
                            <li>活动相关疑问可私信
                                <a href="https://v.douyin.com/NFkqMgUaVpw/" target="_blank"
                                    style="color: #2563eb; text-decoration: none;" class="custom-link">
                                    雪音の小助理
                                </a>
                                （DY：24226809254）。
                            </li>
                        </ul>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 会员权益 -->
        <div class="rulesCard" id="memberRight" ref="ruleCard" data-id="memberRight">
            <el-card>
                <h2 class="rulesTitle">🎫 会员权益</h2>
                <p class="rulesDescription">
                    在直播间内开通各等级会员除可收看每月限定会员直播外，还能兑换专属权益（2026.01版）
                </p>
                <div class="rulesContent">
                    <div class="table-header" style="margin: 10px 0 20px 0;">
                        <h3 style="font-size: 16px; color: #333; font-weight: bold; margin: 0;">
                            🎁 三种会员套餐权益
                        </h3>
                    </div>
                    <el-table :data="memberPackages" border style="width: 100%; margin: 20px 0;">
                        <el-table-column prop="name" label="会员套餐" width="120" />
                        <el-table-column prop="perks" label="必领周边" min-width="200">
                            <template slot-scope="scope">
                                <span v-html="scope.row.perks"></span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="optionalBenefits" label="二选一福利" min-width="200" />
                        <el-table-column prop="note" label="特别说明" />
                    </el-table>

                    <div style="margin: 30px 0; padding: 15px; background: #f8f9fa; border-radius: 8px;">
                        <h3 style="font-size: 15px; color: #333; font-weight: bold; margin: 0 0 10px 0;">
                            📅 周边更新规则
                        </h3>
                        <div style="display: flex; flex-wrap: wrap; gap: 20px; font-size: 14px; color: #666;">
                            <div><strong>小立牌：</strong>12款/年，每月更新1款</div>
                            <div><strong>色纸：</strong>4款/年，每季度更新1款（1、4、7、10月）</div>
                            <div><strong>毛毯：</strong>2款/年（5月、11月各更新1款）<span style="color:#e53e3e; margin-left: 10px;">⚠️
                                    按开通时间发放对应款式</span></div>
                        </div>
                    </div>

                    <!-- 连续开通补领 -->
                    <div style="margin: 30px 0; padding: 15px; background: #fdf2f8; border-radius: 8px;">
                        <h3 style="font-size: 15px; color: #333; font-weight: bold; margin: 0 0 10px 0;">
                            🔄 连续开通补领规则
                        </h3>
                        <ul style="padding-left: 20px; margin: 0; font-size: 14px; color: #666; line-height: 1.8;">
                            <li><strong>季度补领</strong>：连续开通3个月月度会员 → 补领1套季度周边</li>
                            <li><strong>年度补领</strong>：连续开通12个月月度/4个季度会员 → 补领1套年度周边（含1条对应批次毛毯）</li>
                            <li><strong>登记时间</strong>：<span
                                    style="color:#409eff; font-weight: bold;">每年12月统一开放补领登记问卷</span>
                            </li>
                        </ul>
                    </div>

                    <!-- 登记入口 -->
                    <div style="margin: 30px 0;">
                        <h3 style="font-size: 15px; color: #333; font-weight: bold; margin: 0 0 20px 0;">
                            📱 登记入口
                        </h3>
                        <div
                            style="display: flex; flex-wrap: wrap; gap: 40px; justify-content: center; align-items: center;">
                            <!-- 年会/季会登记 -->
                            <div style="text-align: center;">
                                <div style="margin-bottom: 10px; font-size: 14px; color: #666; font-weight: bold;">
                                    年/季度会员登记
                                </div>
                                <div class="qrcode-placeholder"
                                    style="width: 200px; height: 200px; background: #f5f5f5; margin: 0 auto; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #999;">
                                    <img src="../assets/会员登记二维码.png" alt="年/季度会员登记" style="width: 100%; height: 100%;">
                                </div>
                                <div style="margin-top: 10px;">
                                    <el-button type="primary" @click="openLink('annualSeason')" size="small">
                                        点击跳转
                                    </el-button>
                                </div>
                            </div>

                            <!-- 连续开通补领登记 -->
                            <div style="text-align: center;" v-if="registrationMonth()">
                                <div style="margin-bottom: 10px; font-size: 14px; color: #666; font-weight: bold;">
                                    连续开通补领登记（每年12月开放）
                                </div>
                                <div class="qrcode-placeholder"
                                    style="width: 200px; height: 200px; background: #f5f5f5; margin: 0 auto; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #999;">
                                    <img src="../assets/补领登记二维码.png" alt="连续开通补领登记" style="width: 100%; height: 100%;">
                                </div>
                                <div style="margin-top: 10px;">
                                    <el-button type="primary" @click="openLink('continuous')" size="small"
                                        :disabled="true">
                                        点击跳转
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 注意事项 -->
                    <div class="reminder"
                        style="margin-top: 20px; padding: 20px; background: #fff3cd; border-radius: 8px; color: #856404; line-height: 1.8;">
                        <h4 style="margin: 0 0 10px 0; font-size: 15px; font-weight: bold; color: #856404;">
                            ⚠️ 重要注意事项
                        </h4>
                        <ul style="margin: 0; padding-left: 20px; font-size: 14px;">
                            <li>所有福利仅针对首开/续费会员，周边无其他获取渠道</li>
                            <li><strong style="color:#409eff;">发放时间</strong>：会员基础周边每年6月、12月分两次统一发放；连续开通补领的周边随12月批次一同发放
                            </li>
                            <li><strong
                                    style="color:#e53e3e;">毛毯特别说明</strong>：每年更新2款毛毯（5月、11月各1款），年度会员/年度补领仅发放对应开通时间的1款，无法领取全年2款
                            </li>
                            <li>连续开通补领登记问卷每年12月开放，逾期未登记视为自动放弃补领权益</li>
                        </ul>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 官方社群规则 -->
        <div class="rulesCard" id="communityRule" ref="ruleCard" data-id="communityRule">
            <el-card>
                <h2 class="rulesTitle">👥 官方社群规则</h2>
                <p class="rulesDescription">
                    雪音官方社群分为抖音社群和微信社群两大类，不同社群有对应的入群要求及权益，以下是详细说明：
                </p>
                <div class="rulesContent" style="padding: 10px 20px; line-height: 2;">
                    <!-- 一、抖音社群 -->
                    <div style="margin-bottom: 20px;">
                        <span style="font-weight: bold; color: #333; font-size: 15px;">1. 抖音社群</span>
                        <ul style="margin: 8px 0 0 20px; padding: 0; font-size: 14px; color: #666;">
                            <li><strong>普通粉丝群（普1、普2...）</strong>：提交申请后，由管理在后台审批通过后自动加入；</li>
                            <li><strong>会员群（V1、V2...）</strong>：普通会员自动加入（若未自动进群，提交申请后等待管理后台审批）；</li>
                            <li><strong>年会群</strong>：年度会员开通后自动加入（若未自动进群，提交申请后等待管理后台审批），无特殊昵称。</li>
                        </ul>
                    </div>

                    <!-- 二、微信社群 -->
                    <div style="margin-bottom: 20px;">
                        <span style="font-weight: bold; color: #333; font-size: 15px;">2. 微信社群</span>
                        <ul style="margin: 8px 0 0 20px; padding: 0; font-size: 14px; color: #666;">
                            <li><strong>10级粉丝牌专属群（世永一、抽二、晚三、E4、罚五、问六、福七、扬八）</strong>：粉丝牌等级≥10级可申请，需提供等级证明，联系
                                <a href="https://v.douyin.com/rnCavoQqtT4/" target="_blank"
                                    style="color: #2563eb; text-decoration: none;" class="custom-link">
                                    清柠
                                </a>
                                （DY：QingNing_xy0605）审核后邀请入群；
                            </li>
                            <li><strong>年会专属总裁群</strong>：开通年度会员可加入（即“总裁”身份），需提供开通证明，联系
                                <a href="https://v.douyin.com/rnCavoQqtT4/" target="_blank"
                                    style="color: #2563eb; text-decoration: none;" class="custom-link">
                                    清柠
                                </a>
                                （DY：QingNing_xy0605）审核后邀请入群；
                            </li>
                            <li><strong>16级粉丝牌专属群（高材生/养老院）</strong>：粉丝牌等级≥16级可申请，需提供等级证明，联系
                                <a href="https://v.douyin.com/rnCavoQqtT4/" target="_blank"
                                    style="color: #2563eb; text-decoration: none;" class="custom-link">
                                    清柠
                                </a>
                                （DY：QingNing_xy0605）审核后邀请入群；
                            </li>
                        </ul>
                    </div>

                    <!-- 三、入群须知 -->
                    <div style="padding: 15px; background: #f0f9ff; border-radius: 8px; margin-top: 10px;">
                        <span style="font-weight: bold; color: #2563eb;">📌 入群通用须知：</span>
                        <ul style="margin: 8px 0 0 20px; padding: 0; font-size: 14px; color: #666;">
                            <li>微信社群均需提供对应证明（粉丝牌等级录屏、会员开通截图等），仅可通过
                                <a href="https://v.douyin.com/rnCavoQqtT4/" target="_blank"
                                    style="color: #2563eb; text-decoration: none;" class="custom-link">
                                    清柠
                                </a>
                                （DY：QingNing_xy0605）提交申请；
                            </li>
                            <li>审核通过后，清柠将在3个工作日内邀请入群，请耐心等待；</li>
                            <li>社群内请遵守公序良俗，禁止广告、恶意刷屏等行为，多次违反者将移出群聊。</li>
                        </ul>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 人设及皮套使用权限与创作规范 -->
        <div class="rulesCard" id="characterRule" ref="ruleCard" data-id="characterRule">
            <el-card>
                <h2 class="rulesTitle">🎨 人设及皮套使用权限与创作规范</h2>
                <p class="rulesDescription">
                    明确官方人设、官方皮套及粉丝衍生内容（同人人设、饭制皮套）的二创、制品制作等权限规则。
                </p>
                <div class="rulesContent" style="padding: 10px 20px; line-height: 2;">
                    <div style="margin-bottom: 15px;">
                        <span style="font-weight: bold; color: #333;">1. 二创权限：</span>
                        <span>官方人设、官方皮套支持自由二创（画画、剪视频、同人创作等）；粉丝衍生内容（同人人设、饭制皮套）需在其创作者（亲妈）授权后进行二创，鼓励优质衍生内容产出。</span>
                    </div>
                    <div style="margin-bottom: 15px;">
                        <span style="font-weight: bold; color: #333;">2. 制品制作限制：</span>
                        <ul style="margin: 5px 0 0 20px; padding: 0;">
                            <li>👉 官方人设/官方皮套：<span
                                    style="color: #e53e3e; font-weight: 500;">禁止制作任何形式的制品</span>（包括自印、批量制作等），仅可用于二创参考。
                            </li>
                            <li>👉 粉丝衍生内容（同人人设、饭制皮套等）：<span
                                    style="color: #409eff; font-weight: 500;">允许少量自印制品，用于个人收藏、无偿赠送或粉丝抽奖</span>；禁止批量印制售卖。
                            </li>
                        </ul>
                    </div>
                    <div style="margin-bottom: 15px;">
                        <span style="font-weight: bold; color: #333;">3. 开团禁令：</span>
                        <span>无论官方人设、官方皮套，还是粉丝衍生内容（同人人设、饭制皮套），均<span
                                style="color: #e53e3e; font-weight: 500;">禁止以任何形式开团制作周边</span>（如棉花娃娃、徽章、钥匙扣等），无论是否盈利。</span>
                    </div>
                    <div style="padding: 10px; background: #f0f9ff; border-radius: 6px; margin-top: 10px;">
                        <span style="font-weight: bold; color: #2563eb;">📌 特别说明：</span>
                        <span>基于“法不溯及既往”原则，2026年1月1日前已完成官方报备并获得批准的饭制相关团，<span
                                style="font-weight: 500;">不受本规范中开团禁令的限制。</span></span>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 周边相关 -->
        <div class="rulesCard" id="peripheralRule" ref="ruleCard" data-id="peripheralRule">
            <el-card>
                <h2 class="rulesTitle">🎁 周边发放&使用须知</h2>
                <p class="rulesDescription">
                    官方周边的使用、兑换、售后等相关规则
                </p>
                <div class="rulesContent" style="padding: 10px 20px; line-height: 2;">
                    <!-- 一、使用限制 -->
                    <div style="margin-bottom: 15px;">
                        <span style="font-weight: bold; color: #333;">1. 周边使用限制：</span>
                        <ul style="margin: 5px 0 0 20px; padding: 0;">
                            <li> 禁止以官方周边牟利，包括但不限于出售、有偿转让等行为；一旦发现，将直接拉黑并永久取消后续活动参与资格。</li>
                            <li> 禁止以盈利为目的进行任何周边抽奖、赠送等行为。</li>

                        </ul>
                    </div>

                    <!-- 二、兑换与发放 -->
                    <div style="margin-bottom: 15px;">
                        <span style="font-weight: bold; color: #333;">2. 兑换与发放规则：</span>
                        <ul style="margin: 5px 0 0 20px; padding: 0;">
                            <li> 抽奖奖品兑奖时效为48小时，超时未兑奖视为自动放弃。</li>
                            <li> 港澳台及海外用户须填写中转站地址，海外地址无法寄出。</li>
                            <li> 有被拉黑记录、违规记录或不良言论记录的用户，不予发放周边。</li>
                        </ul>
                    </div>

                    <!-- 三、售后与补发 -->
                    <div>
                        <span style="font-weight: bold; color: #333;">3. 售后与补发说明：</span>
                        <ul style="margin: 5px 0 0 20px; padding: 0;">
                            <li>因拒收、快递无法联系导致包裹退回的，不予追补。</li>
                            <li>收到快递后请录制开箱视频，若出现漏发、暴力快递等问题，需凭开箱视频售后；无视频则不予补换。</li>
                        </ul>
                    </div>
                </div>
            </el-card>

        </div>
        <!-- 人气票打榜规则 -->
        <div class="rulesCard" id="popularityVote" ref="ruleCard" data-id="popularityVote">
            <el-card>
                <h2 class="rulesTitle">🏆 人气票打榜规则</h2>
                <p class="rulesDescription">
                    人气票打榜通过赠送专属礼物增加主播人气值，规则及人气值计算方式如下：
                </p>
                <div class="rulesContent" style="padding: 10px 20px; line-height: 2;">
                    <!-- 一、参与&操作规则（强化重点样式） -->
                    <div style="margin-bottom: 25px; padding: 15px; background: #f8f9fa; border-radius: 8px;">
                        <span
                            style="font-weight: bold; color: #333; font-size: 15px; display: block; margin-bottom: 10px;">
                            📌 核心操作规则
                        </span>
                        <ul style="margin: 0; padding-left: 20px; font-size: 14px; color: #666; line-height: 1.8;">
                            <li><strong style="color: #e53e3e;">参与无门槛</strong>：无需挂时长、未加入粉丝团也可赠送；未成年人禁止参与。</li>
                            <li><strong style="color: #409eff;">操作方式</strong>：可长按批量赠送；11级+灯牌用户每小时57分可“守塔”。</li>
                            <li><strong style="color: #f59e0b;">数量限制</strong>：每人每小时最多600张，超量不计人气值。</li>
                        </ul>
                    </div>

                    <!-- 二、人气值计算标准（优化排版+简化活动加成） -->
                    <div style="margin-bottom: 20px;">
                        <span
                            style="font-weight: bold; color: #333; font-size: 15px; display: block; margin-bottom: 10px;">
                            🔢 人气值计算标准
                        </span>
                        <p style="margin: 0 0 10px 0; font-size: 14px; color: #666;">
                            人气值 = 「单张人气票对应值 × 赠送数量」 + 「每小时首张票额外奖励」
                        </p>
                        <el-table :data="popularityRules" border size="small"
                            style="width: 100%; margin: 0 0 12px 0; font-size: 14px;"
                            :header-cell-style="{ background: '#f5fafe', color: '#333', 'font-weight': 'bold' }">
                            <el-table-column prop="level" label="粉丝团等级" align="center"
                                min-width="120px"></el-table-column>
                            <el-table-column prop="singleValue" label="单张人气票对应值" align="center"
                                min-width="120px"></el-table-column>
                            <el-table-column prop="firstReward" label="每小时首张票额外奖励" align="center"
                                min-width="150px"></el-table-column>
                            <el-table-column prop="hourlyLimit" label="每小时人气值上限" align="center"
                                min-width="120px"></el-table-column>
                        </el-table>

                        <p
                            style="margin: 0; padding: 8px 12px; background: #e6fffa; border-radius: 6px; font-size: 13px; color: #059669;">
                            ✨ 活动加成：「人气冲刺」期间，星守护用户人气值享1.5倍加成，每小时最多额外贡献2500人气值。
                        </p>
                        <p
                            style="margin: 0; padding: 8px 12px; background: #e6fffa; border-radius: 6px; font-size: 13px; color: #059669;">
                            ✨ 人气开场：「人气开场」通过后，本播间全体用户人气值享1.3倍加成，每小时最多额外贡献1500人气值。
                        </p>
                    </div>
                </div>
            </el-card>
        </div>

<!-- 人气开场规则板块 - 精简版 -->
<div class="rulesCard" id="popularityOpening" ref="ruleCard" data-id="popularityOpening">
    <el-card>
        <h2 class="rulesTitle">🔥 人气开场规则</h2>
        <p class="rulesDescription">
            开播30分钟内，送「跑车」或「鲜花」加入挑战，后续送礼/点赞计入活动值，达标解锁奖励。
        </p>
        <div class="rulesContent" style="padding: 10px 0px 0px 0px; line-height: 1.8;">
            
            <!-- 一、加入方式 -->
            <div style="margin-bottom: 16px;">
                <div style="font-weight: bold; color: #d97706; margin-bottom: 8px;">🎯 加入挑战</div>
                <div style="font-size: 14px; color: #666;">送「<strong style="color: #e53e3e;">跑车</strong>」或「<strong style="color: #e53e3e;">鲜花</strong>」→ 获得资格</div>
            </div>

            <!-- 二、活动值计算 -->
            <div style="margin-bottom: 16px;">
                <div style="font-weight: bold; color: #d97706; margin-bottom: 8px;">💰 活动值计算</div>
                <div style="display: flex; flex-wrap: wrap; gap: 12px; font-size: 14px;">
                    <span style="background: #fef3c7; padding: 4px 12px; border-radius: 16px;">🚗 跑车：1.5倍</span>
                    <span style="background: #fef3c7; padding: 4px 12px; border-radius: 16px;">🌸 鲜花：1.2倍</span>
                    <span style="background: #f0f9ff; padding: 4px 12px; border-radius: 16px;">🎁 其他礼物：1倍</span>
                    <span style="background: #fef2f2; padding: 4px 12px; border-radius: 16px;">🧧 开场红包所获礼物：2倍</span>
                </div>
                <div style="font-size: 13px; color: #666; margin-top: 8px;">👍 点赞：每100赞=1点活动值（单场上限10点）</div>
            </div>

            <!-- 三、奖励 -->
            <div style="margin-bottom: 16px;">
                <div style="font-weight: bold; color: #d97706; margin-bottom: 8px;">🏆 奖励</div>
                <div style="display: flex; flex-wrap: wrap; gap: 12px; font-size: 14px;">
                    <span style="background: #fef3c7; padding: 4px 12px; border-radius: 16px;">阶段1：激活人气彩蛋挑战</span>
                    <span style="background: #fef3c7; padding: 4px 12px; border-radius: 16px;">阶段2：人气彩蛋挑战成功，实时加热</span>
                    <span style="background: #fef3c7; padding: 4px 12px; border-radius: 16px;">阶段3：即刻起15分钟内人气票30%加成</span>
                </div>
                <div style="font-size: 13px; color: #666; margin-top: 8px;">📅 累计助力7/14/21天 → 额外奖励 | 🧧 发红包抢C位</div>
            </div>

            <!-- 四、上限说明 -->
            <div style="font-size: 13px; color: #999; border-top: 1px solid #eee; padding-top: 10px;">
                ⚠️ 单用户加成最高5倍（含礼物+红包等叠加）
            </div>
        </div>
    </el-card>
</div>
    </div>
</template>

<script>
import Clipboard from 'clipboard';
import NavMenu from '@/components/NavMenu.vue';

export default {
    components: {
        NavMenu
    },
    data() {
        return {
            songListTypes: [
                {
                    name: '🏆 优先歌单',
                    cost: '升级仪式：0积分/首<br>纪念日：1积分/首',
                    priority: '最高',
                    orderMethod: 'admin',
                    orderMethodText: '联系管理',
                    note: '16级以上升级仪式/入团纪念日专属',
                },
                {
                    name: '🔝 置顶歌单',
                    cost: '100–450积分/首',
                    priority: '高于插队歌单',
                    orderMethod: 'app',
                    orderMethodText: '小程序下单',
                    note: '可指定日期，下单时需额外备注'
                },
                {
                    name: '⏭️ 插队歌单',
                    cost: '50–75积分/首',
                    priority: '高于普通歌单',
                    orderMethod: 'app',
                    orderMethodText: '小程序下单',
                    note: ''
                },
                {
                    name: '🎧 普通歌单',
                    cost: '10–35积分/首',
                    priority: '普通',
                    orderMethod: 'app',
                    orderMethodText: '小程序下单',
                    note: ''
                },
                {
                    name: '🎓 学歌歌单',
                    cost: '100–450积分/首',
                    priority: '学歌队列单独排序',
                    orderMethod: 'app',
                    orderMethodText: '小程序下单',
                    note: '排到后周内个播交付，仅接受国语歌曲'
                },
            ],
            creationPointsRules: [
                { likeCount: '≥930', points: 1 },
                { likeCount: '≥1520', points: 3 },
                { likeCount: '≥2000', points: 7 },
                { likeCount: '≥2930', points: 10 },
                { likeCount: '≥5000', points: 20 },
                { likeCount: '≥10000', points: 50 },
            ],
            memberPackages: [
                {
                    name: '年度会员',
                    perks: '小立牌×12 + 色纸×4 + 毛毯×1（按开通时间发放对应款式）<br>👉 <span style="color:#e53e3e;">年会专属微信群（总裁群）联系管理加群</span>',
                    optionalBenefits: '个播插队点歌×1 或 登记12积分',
                    note: '权益最全'
                },
                {
                    name: '季度会员',
                    perks: '小立牌×3 + 色纸×1',
                    optionalBenefits: '档上点歌×1 或 登记3积分',
                    note: '性价比高'
                },
                {
                    name: '月度会员',
                    perks: '无',
                    optionalBenefits: '档上点歌×1 或 登记1积分',
                    note: '灵活选择'
                }
            ],
            registerLinks: {
                annualSeason: 'https://www.wjx.top/vm/h4LoeGR.aspx',
                continuous: 'https://www.wjx.top/vm/PvfYDbS.aspx'
            },
            ruleNavItems: [
                { id: 'songRule', name: '点歌规则' },
                { id: 'pointExchange', name: '积分兑换规则' },
                { id: 'creationPoint', name: '二创积分规则' },
                { id: 'memberRight', name: '会员权益' },
                { id: 'communityRule', name: '官方社群规则' },
                { id: 'characterRule', name: '人设及皮套使用规范' },
                { id: 'peripheralRule', name: '周边发放&使用须知' },
                { id: 'popularityVote', name: '人气票打榜规则' },
                 { id: 'popularityOpening', name: '人气开场规则' }, 

            ],
            popularityRules: [
                { level: '非粉丝团', singleValue: 4, firstReward: 200, hourlyLimit: 2600 },
                { level: '1-2级', singleValue: 5, firstReward: 200, hourlyLimit: 3200 },
                { level: '3-5级', singleValue: 6, firstReward: 200, hourlyLimit: 3800 },
                { level: '6-10级', singleValue: 7, firstReward: 200, hourlyLimit: 4400 },
                { level: '11-20级', singleValue: 8, firstReward: 200, hourlyLimit: 5000 },
            ],
            songList: '',
            douyinNickname: '',
            douyinId: '',
            songNote: '',
            giftPrice: '',
            giftQuantity: 1,
            calculationPool: [],
            poolItemId: 100,
            totalDiamonds: 0,
            totalPoints: 0,
            totalOverflow: 0,
            clipboard: null,
            isTemplateCollapse: true,
            isQrcodeCollapse: true,
            activeName: 'first'
        }
    },
    mounted() {
        this.initClipboard();
    },
    beforeDestroy() {
        if (this.clipboard) {
            this.clipboard.destroy();
        }
    },
    methods: {
        initClipboard() {
            this.clipboard = new Clipboard('#copyBtn', {
                text: () => {
                    return `【点歌备注】
歌名：${this.songList || '未填写'}
抖音昵称：${this.douyinNickname || '未填写'}
抖音ID：${this.douyinId || '未填写'}
备注：${this.songNote || '无'}`;
                }
            });

            this.clipboard.on('success', (e) => {
                this.$message.success('复制成功!');
                e.clearSelection();
            });

            this.clipboard.on('error', () => {
                this.$message.error('复制失败，请手动复制。');
            });
        },
        clearTemplate() {
            this.songList = '';
            this.douyinNickname = '';
            this.douyinId = '';
            this.songNote = '';
        },
        toggleTemplate() {
            this.isTemplateCollapse = !this.isTemplateCollapse;
        },
        toggleQrcode() {
            this.isQrcodeCollapse = !this.isQrcodeCollapse;
        },
        addToPool() {
            if (!this.giftPrice || this.giftPrice < 1) {
                this.$message.warning('请输入有效的礼物单价（≥1钻）');
                return;
            }
            const totalPrice = this.giftPrice * this.giftQuantity;
            const singlePoint = Math.floor(this.giftPrice / 599);
            const points = singlePoint * this.giftQuantity;
            this.calculationPool.push({
                id: this.poolItemId++,
                price: this.giftPrice,
                quantity: this.giftQuantity,
                totalPrice: totalPrice,
                singlePoint: singlePoint,
                points: points
            });
            this.giftPrice = '';
            this.giftQuantity = 1;
            this.calculateAllPoints();
        },
        removeFromPool(id) {
            const index = this.calculationPool.findIndex(item => item.id === id);
            if (index > -1) {
                this.calculationPool.splice(index, 1);
            }
            this.calculateAllPoints();
        },
        clearPool() {
            this.calculationPool = [];
            this.totalDiamonds = 0;
            this.totalPoints = 0;
            this.totalOverflow = 0;
        },
        calculateAllPoints() {
            if (this.calculationPool.length === 0) {
                this.totalDiamonds = 0;
                this.totalPoints = 0;
                this.totalOverflow = 0;
                return;
            }

            this.totalDiamonds = 0;
            this.totalPoints = 0;

            this.calculationPool.forEach(item => {
                this.totalDiamonds += item.totalPrice;
                this.totalPoints += item.points;
            });

            this.totalOverflow = this.totalDiamonds - (this.totalPoints * 599);
        },
        openLink(type) {
            window.open(this.registerLinks[type], '_blank');
        },
        registrationMonth() {
            const currentMonth = new Date().getMonth() + 1;
            return currentMonth === 12;
        }
    }
}
</script>

<style scoped>
/* 核心调整：统一根容器样式，和首页保持一致 */
.playlist-container {
    padding: 20px;
    /* 和首页一致的内边距 */
    max-width: 1200px;
    /* 核心：统一最大宽度为1200px */
    margin: 0 auto;
    /* 居中显示，和首页对齐 */
    width: 100%;
    /* 宽度自适应 */
    overflow-x: auto;
    /* 仅窄屏时触发横向滚动 */
    -webkit-overflow-scrolling: touch;
    /* 优化移动端滚动体验 */
    box-sizing: border-box;
    /* 防止内边距撑宽容器 */
}

/* 移除main-content的独立宽度限制，统一由根容器控制 */
.main-content {
    padding: 0;
    margin: 0 0 30px 0;
    width: 100%;
    box-sizing: border-box;
}

.playlist-title-card {
    text-align: center;
    margin-bottom: 30px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border: none;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.playlist-title {
    font-size: 28px;
    color: #ffad32;
    margin-bottom: 10px;
    letter-spacing: 2px;
    font-weight: bold;
}

.playlist-description {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
}

.rulesCard {
    padding: 0 0 20px 0;
    /* 移除左右内边距，由根容器统一控制 */
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
}

/* 给rulesCard内的el-card添加内边距，保证内容间距 */
.rulesCard>.el-card {
    padding: 20px;
    border-radius: 10px;
    box-sizing: border-box;
}

.rulesDescription {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
}

.rulesContent {
    padding: 0px 0px 20px 0px;
    width: 100%;
    box-sizing: border-box;
}

.rule-calculator-container {
    display: flex;
    align-items: stretch;
    width: 100%;
    gap: 10px;
    flex-wrap: wrap;
    box-sizing: border-box;
}

.rule-section {
    flex: 2;
    min-width: unset;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.calculator-section {
    flex: 1;
    min-width: unset;
    width: 100%;
    display: flex;
    align-items: stretch;
    margin-left: 0;
    border-left: none;
    padding-left: 0;
    box-sizing: border-box;
}

/* 优化响应式样式 */
@media (max-width: 992px) {
    .rule-calculator-container {
        flex-direction: column;
    }

    .calculator-section {
        margin-left: 0;
        border-left: none;
        padding-left: 0;
        margin-top: 20px;
        border-top: 1px solid #e6e6e6;
        padding-top: 20px;
    }
}

/* 移动端适配：和首页保持一致的内边距调整 */
@media (max-width: 768px) {
    .playlist-container {
        padding: 10px;
        /* 小屏缩小内边距，和首页一致 */
    }

    .rulesCard>.el-card {
        padding: 15px;
        /* 小屏缩小卡片内边距 */
    }

    .playlist-title {
        font-size: 24px;
        /* 小屏缩小标题字号 */
    }
}

.rulesTitle {
    font-size: 25px;
    color: #ffad32;
    margin-bottom: 10px;
    font-weight: bold;
}

.exchange-core,
.exchange-exclude,
.exchange-notice {
    flex-shrink: 0;
    margin: 20px 0;
}

.input-section {
    width: 100%;
    max-width: 450px;
    padding: 20px;
    border-radius: 18px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin: 0 auto;
}

@media (max-width: 500px) {
    .input-section {
        width: 100%;
        max-width: unset;
    }

    .mini-program-section {
        width: 100%;
    }
}

.template-title {
    font-size: 18px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 500;
}

.template-form {
    margin-bottom: 20px;
}

.form-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    width: 100%;
    box-sizing: border-box;
}

.form-label {
    width: 80px;
    font-size: 14px;
    color: #666;
    line-height: 32px;
    flex-shrink: 0;
    text-align: right;
    margin-right: 12px;
}

.form-input {
    flex: 1;
    width: 100%;
    box-sizing: border-box;
}

.template-buttons {
    display: flex;
    gap: 12px;
    justify-content: flex-start;
    padding-top: 8px;
    width: 100%;
    box-sizing: border-box;
}

.mini-program-section {
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
    box-sizing: border-box;
}

.qrcode-placeholder {
    width: 200px;
    height: 200px;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    margin: 0 auto;
}

.collapse-control {
    border-bottom: 1px dashed #e6e6e6;
    padding-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
}

.collapse-control .el-button {
    font-size: 14px;
    color: #333;
    padding: 0;
}

.collapse-control .el-button:hover {
    color: #409eff;
}

::v-deep .custom-tooltip .el-tooltip__popper.is-light {
    border: none !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
    background-color: #ffffff !important;
    padding: 10px 12px !important;
    border-radius: 8px !important;
}

.special-notice {
    background-color: #e6fffa !important;
    border: 1px solid #99f6e4 !important;
}

.custom-link {
    color: #409eff;
    text-decoration: none;
    font-weight: 500;
    position: relative;
}

.custom-link:hover {
    color: #1e88e5;
    text-decoration: underline;
}

.custom-link::after {
    content: "点击跳转";
    position: absolute;
    top: -30px;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-size: 12px;
    padding: 3px 10px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
}

.custom-link:hover::after {
    opacity: 1;
}

.rulesCard {
    transition: all 0.3s ease;
}

::v-deep .el-input__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.playlist-container a {
    color: #409eff;
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.2s ease;
    margin: 0 8px;
}

.playlist-container a:hover {
    color: #1e88e5;
    text-decoration: underline;
}
</style>